import { z } from 'zod'

import { isoDateTime } from '../lib/date'

// ---------------------------------------------------------------------------
// Stock — snapshot summary row for a (clinic, product[, batch]) combination
// ---------------------------------------------------------------------------

export const stockSchema = z.object({
  id: z.string(),
  productId: z.string(),
  clinicId: z.string(),
  batchNumber: z.string().nullable(),
  /** Current stock level — sum of intakes minus sum of order allocations. */
  quantity: z.number(),
  expiryDate: z.iso.date().nullable(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
})

export type Stock = z.output<typeof stockSchema>

// ---------------------------------------------------------------------------
// Batch allocation — a single batch contribution to an order.
// ---------------------------------------------------------------------------

export const batchAllocationItemSchema = z.object({
  /** Null for products not tracked by batch number. */
  batchNumber: z.string().nullable(),
  quantity: z.number().positive().multipleOf(0.01),
})

export type BatchAllocationItem = z.infer<typeof batchAllocationItemSchema>
